import React from 'react';

import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const CustomDialog = ({
  isOpen, 
  open,
  onClose, 
  children,
  title = '',
  fullWidth = false,
  maxWidth = 'sm',
  actionButtons = [],
  showCloseButton = true,
  backgroundColor = '#ffffff',
  padding = null,
}) => {
  const _isOpen = isOpen || open;
  return (
    <StyledDialog 
      open={_isOpen} 
      onClose={onClose} 
      maxWidth={maxWidth} 
      fullWidth={fullWidth}
      sx={{borderRadius: '16px'}}
    >
      <DialogTitle style={{backgroundColor}}>
        <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between'>
          <Stack direction='row' spacing={1} justifyContent='left' style={{flexGrow: 1}}>
            <Typography variant='h1' style={{paddingLeft: '1.5em'}}>{title}</Typography>
          </Stack>
          {showCloseButton && 
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          }
        </Stack>
      </DialogTitle>
      <Divider/>
      <DialogContent style={{backgroundColor, padding}}>
        {children}
      </DialogContent>
      <DialogActions style={{backgroundColor}}>
        {(actionButtons || []).map(Button => (<Button />))}
      </DialogActions>
    </StyledDialog>
  );
};

export default CustomDialog;

